module.exports = __webpack_public_path__ + "static/media/audio-mode-active.a3d8efc3.svg";